import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';

const MAX_BYTES = 10 * 1024 * 1024;
const ALLOWED_MIME = /^(application\/pdf|image\/(jpeg|png|webp|heic|heif))$/;

export function intygPath(boatId: string, filename: string): string {
  const uuid = crypto.randomUUID();
  // Strip only path separators and control characters; preserve åäö and other Unicode.
  const safe = filename.replace(/[\\/\x00-\x1f\x7f]+/g, '_');
  return `intyg/${boatId}/${uuid}-${safe}`;
}

export async function uploadIntyg(boatId: string, file: File): Promise<string> {
  if (file.size > MAX_BYTES) {
    throw new Error('Filen är för stor (max 10 MB).');
  }
  if (!ALLOWED_MIME.test(file.type)) {
    throw new Error('Otillåten filtyp. Endast PDF eller bild (jpeg/png/webp/heic).');
  }
  const path = intygPath(boatId, file.name);
  const r = ref(storage, path);
  await uploadBytes(r, file);
  return path;
}

export async function getIntygUrl(fileRef: string): Promise<string> {
  return getDownloadURL(ref(storage, fileRef));
}

export async function deleteIntyg(fileRef: string): Promise<void> {
  await deleteObject(ref(storage, fileRef));
}
